export const NewsletterSourceRegistration = "NewsletterSourceRegistration";
export const NewsletterSourceMainPage     = "NewsletterSourceMainPage";

const SubscribedToNewsletterEvent = "SubscribedToNewsletter";

export const subscribedToNewsletter = (email, source) => {
  //  Event snippet for Registrierung Newsletter conversion page
  if (typeof gtag === 'undefined') return
  gtag('event', 'conversion', {
    'send_to': 'AW-432749837/dpRJCOP85fkBEI36rM4B',
    event: SubscribedToNewsletterEvent,
    newsletterSubscriptionSource: source,
  })
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: SubscribedToNewsletterEvent,
    newsletterSubscriptionSource: source
  })
}
